// v414.28 — customer-friendly function taglines shown under the product name
// on storefront cards. Simple language, no science jargon (per owner).
// Matching: compact-prefix against the store product name, longest key first
// (so "melanotanii" wins over "melanotani", "cjc1295dac" over "cjc1295").

const FUNCTION_MAP = {
  // Injectables
  aod9604: "Targeted fat loss",
  ara290: "Nerve pain management",
  "5amino1mq": "Metabolism & fat-burning support",
  bpc157: "Injury repair & gut healing",
  tb500: "Injury recovery & flexibility",
  cartalax: "Joint & cartilage repair",
  kpv: "Inflammation & gut calm",
  klow: "Total-body repair blend",
  wolverine: "Ultimate healing stack",
  cerebrolysin: "Brain repair & mental clarity",
  dihexa: "Memory & learning support",
  semax: "Focus & mental clarity",
  selank: "Calm focus & stress relief",
  pinealon: "Brain health & recovery",
  dsip: "Deep, restorative sleep",
  epitalon: "Longevity & anti-aging",
  nad: "Cellular energy & anti-aging",
  ss31: "Cellular energy & heart health",
  glutathione: "Detox & antioxidant support",
  reducedglutathione: "Detox & antioxidant support",
  motsc: "Energy & metabolic boost",
  slupp332: "Exercise-mimicking endurance & fat burn",
  tirzepatide: "Appetite control & weight loss",
  retatrutide: "Advanced weight loss support",
  ghkcu: "Skin, hair & collagen renewal",
  hkcu: "Skin, hair & collagen renewal",
  glow70: "Skin glow & anti-aging blend",
  bbg70: "Skin glow & anti-aging blend",
  snap8: "Wrinkle smoothing (botox-like)",
  melanotani: "Sun-kissed tan support",
  melanotanii: "Tanning & libido boost",
  pt141: "Desire & performance",
  kisspeptin: "Natural hormone & libido support",
  oxytocin: "Connection & mood support",
  cjc1295dac: "Growth hormone & recovery support",
  cjc1295: "Growth hormone & recovery support",
  cjcipa: "Muscle growth & recovery blend",
  cp20: "Muscle growth & recovery blend",
  tesamorelin: "Belly fat reduction & lean muscle",
  tesaipa: "Growth hormone & lean muscle blend",
  hgh: "Muscle, recovery & anti-aging",
  thymosinalpha1: "Immune system support",
  ta1: "Immune system support",
  // Precision Nasal Mists (AXIS line)
  axiscognition: "Memory & learning support",
  axisconnect: "Connection & mood support",
  axisdrive: "Desire & performance",
  axisenergy: "Energy & metabolic boost",
  axisfocus: "Focus & mental clarity",
  axisfuel: "Cellular energy & anti-aging",
  axismetabolic: "Targeted fat loss",
  axisneurorepair: "Brain repair & mental clarity",
  axisrecover: "Brain health & recovery",
  axisshield: "Cellular energy & heart health",
  axissleep: "Deep, restorative sleep",
  axiszen: "Calm focus & stress relief",
  // Flagship Topical
  axisi: "Skin firming & wrinkle smoothing",
};

// v414.89 — Spanish (es-MX) taglines, approved by the owner
// (drafts: /app/memory/phase2_es_drafts.md). Same keys as FUNCTION_MAP;
// English is the fallback for any key missing here.
const FUNCTION_MAP_ES = {
  aod9604: "Pérdida de grasa localizada",
  ara290: "Manejo del dolor neuropático",
  "5amino1mq": "Apoyo al metabolismo y quema de grasa",
  bpc157: "Reparación de lesiones y salud intestinal",
  tb500: "Recuperación de lesiones y flexibilidad",
  cartalax: "Reparación de articulaciones y cartílago",
  kpv: "Calma la inflamación y el intestino",
  klow: "Mezcla de reparación integral",
  wolverine: "El stack definitivo de recuperación",
  cerebrolysin: "Reparación cerebral y claridad mental",
  dihexa: "Apoyo a la memoria y el aprendizaje",
  semax: "Enfoque y claridad mental",
  selank: "Enfoque sereno y alivio del estrés",
  pinealon: "Salud cerebral y recuperación",
  dsip: "Sueño profundo y reparador",
  epitalon: "Longevidad y antienvejecimiento",
  nad: "Energía celular y antienvejecimiento",
  ss31: "Energía celular y salud cardiaca",
  glutathione: "Detox y apoyo antioxidante",
  reducedglutathione: "Detox y apoyo antioxidante",
  motsc: "Impulso de energía y metabolismo",
  slupp332: "Resistencia y quema de grasa tipo ejercicio",
  tirzepatide: "Control del apetito y pérdida de peso",
  retatrutide: "Apoyo avanzado para pérdida de peso",
  ghkcu: "Renovación de piel, cabello y colágeno",
  hkcu: "Renovación de piel, cabello y colágeno",
  glow70: "Mezcla de luminosidad y antienvejecimiento",
  bbg70: "Mezcla de luminosidad y antienvejecimiento",
  snap8: "Suaviza arrugas (efecto tipo botox)",
  melanotani: "Bronceado gradual y uniforme",
  melanotanii: "Bronceado e impulso de la libido",
  pt141: "Deseo y desempeño",
  kisspeptin: "Apoyo hormonal natural y libido",
  oxytocin: "Conexión y buen estado de ánimo",
  cjc1295dac: "Hormona de crecimiento y recuperación",
  cjc1295: "Hormona de crecimiento y recuperación",
  cjcipa: "Mezcla de crecimiento muscular y recuperación",
  cp20: "Mezcla de crecimiento muscular y recuperación",
  tesamorelin: "Reducción de grasa abdominal y músculo magro",
  tesaipa: "Mezcla de hormona de crecimiento y músculo magro",
  hgh: "Músculo, recuperación y antienvejecimiento",
  thymosinalpha1: "Apoyo al sistema inmune",
  ta1: "Apoyo al sistema inmune",
  axiscognition: "Apoyo a la memoria y el aprendizaje",
  axisconnect: "Conexión y buen estado de ánimo",
  axisdrive: "Deseo y desempeño",
  axisenergy: "Impulso de energía y metabolismo",
  axisfocus: "Enfoque y claridad mental",
  axisfuel: "Energía celular y antienvejecimiento",
  axismetabolic: "Pérdida de grasa localizada",
  axisneurorepair: "Reparación cerebral y claridad mental",
  axisrecover: "Salud cerebral y recuperación",
  axisshield: "Energía celular y salud cardiaca",
  axissleep: "Sueño profundo y reparador",
  axiszen: "Enfoque sereno y alivio del estrés",
  axisi: "Reafirma la piel y suaviza arrugas",
};

const KEYS = Object.keys(FUNCTION_MAP).sort((a, b) => b.length - a.length);
const compact = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]/g, "");

export function findProductFunction(productName, lang = "en") {
  const pc = compact(productName);
  if (!pc) return null;
  for (const k of KEYS) {
    if (pc.startsWith(k)) {
      if (lang === "es" && FUNCTION_MAP_ES[k]) return FUNCTION_MAP_ES[k];
      return FUNCTION_MAP[k];
    }
  }
  return null;
}
